// import product1 from '../../assets/muvtech/product1.png';
// import product2 from '../../assets/muvtech/product2.png';
// import product3 from '../../assets/muvtech/product3.png';
// import sec from '../../assets/muvtech/sec.png';
import yorkcase from '../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap.png';
import pocketpro from '../../assets/muvtech/Muvdata/powerbank/pocketpro.png';
import prosheild from '../../assets/muvtech/Muvdata/ipadGlass/ProShield11-13pro.png';

import { useEffect, useState } from 'react';

// swiper
import { Navigation, Pagination } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { useNavigate } from 'react-router-dom';

function MuvtechFancy() {
  const navigate = useNavigate();

  // condition Navigation

  const [showNavigation, setShowNavigation] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setShowNavigation(window.innerWidth <= 480);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="product-fancy">
      <div className="bg-circle">
        <h1 className="bg-brand-title">MUVTECH</h1>
        <Swiper
          speed={1400}
          modules={[Pagination, Navigation]}
          // navigation
          pagination={showNavigation ? { clickable: true } : false}
          navigation={!showNavigation}
          // pagination={{ type: 'progressbar', clickable: true }}

          slidesPerView={1}
          spaceBetween={30}
          // autoplay={{ delay: 3000, disableOnInteraction: false }} // Auto-slide every 2s
          style={{
            position: 'absolute',
            // width: '180%',
            // height: '70%',
            height: '80%',
            // backgroundColor: 'green',
          }}
          className="fancy-swiper"
        >
          <SwiperSlide
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div className="fancyCard">
              <h2>YORK SNAP</h2>
              <h4>iPhone 16 Series</h4>
              <p>Rs. 1999</p>
              {/* <img src={sec} alt="sec" /> */}
              <button
                onClick={() =>
                  navigate('/muvtech/products-list/details/iphonecase/6')
                }
              >
                VIEW PRODUCT
              </button>
            </div>
            <img src={yorkcase} alt="p1" />
          </SwiperSlide>
          <SwiperSlide
            style={{
              display: 'flex',
              justifyContent: 'center',
              // backgroundColor: 'blue',
              position: 'relative',
            }}
          >
            <div className="fancyCard">
              <h2>POCKET PRO</h2>
              <h4>All Smartphones</h4>
              <p>Rs. 3999</p>
              {/* <img src={sec} alt="sec" /> */}
              <button
                onClick={() =>
                  navigate('/muvtech/products-list/details/powerbank/7')
                }
              >
                VIEW PRODUCT
              </button>
            </div>
            <img src={pocketpro} alt="p1" />
          </SwiperSlide>

          <SwiperSlide
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div className="fancyCard">
              <h2>Pro Shield Glass</h2>
              <h4>ipad 13 pro</h4>
              <p>Rs. 2199</p>
              {/* <img src={sec} alt="sec" /> */}
              <button
                onClick={() =>
                  navigate('/muvtech/products-list/details/ipadglass/1')
                }
              >
                VIEW PRODUCT
              </button>
            </div>
            <img className="fancycard3" src={prosheild} alt="p1" />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}

export default MuvtechFancy;
